import axios from 'axios'
import {Response} from '../_metronic/helpers'

const API_URL = process.env.REACT_APP_MICROSOLUTIONS_URL
const signS3 = (data: any): Promise<any | undefined> => {
  return axios.post(`${API_URL}/sign_s3`, data)
}
const getTaxRates = (query: string): Promise<TaxratesQueryResponse> => {
  return axios.get(`${API_URL}/taxrate?${query}`)
}
const verifyPromotionCode = (data: {
  code: string
  amount?: number
  email?: string
}): Promise<PromotionCode> => {
  return axios.post(`${process.env.REACT_APP_AFFILIATE_URL}/promotion-code/verify`, data)
}

export {signS3, getTaxRates, verifyPromotionCode}
export type Taxrate = {
  stripe_tax_rate_id: string
  name: string
  description: string
  percentage: number
  inclusive: boolean
  country: string
  state: string
}
type TaxratesQueryResponse = Response<Array<Taxrate>>
export type PromotionCode = {
  id: number
  coupon_value: number
  coupon_type: 'percentage' | 'fixed'
}
